var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.62 6.206a.702.702 0 00-.25-.366 2.783 2.783 0 00-.463-.453L10.544.468a2.795 2.795 0 00-3.087 0L1.093 5.387A2.83 2.83 0 00.002 7.612v7.576A2.815 2.815 0 002.814 18h8.647a.703.703 0 000-1.406H2.814c-.776 0-1.406-.63-1.406-1.406V7.612c0-.433.204-.848.546-1.113l6.331-4.895a1.396 1.396 0 011.43 0l6.135 4.743-6.132 4.639a1.397 1.397 0 01-1.437-.001l-4.167-3.12A.703.703 0 103.27 8.99l4.194 3.14A2.807 2.807 0 009 12.591a2.807 2.807 0 001.538-.463l6.053-4.58.002.064v1.46a.703.703 0 001.405 0v-1.46a2.82 2.82 0 00-.378-1.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.792 13.471L15.716 11.4a1.049 1.049 0 00-1.48 0l-2.077 2.072a.703.703 0 10.993.995l1.12-1.118v3.949a.703.703 0 101.407 0v-3.949l1.12 1.118a.7.7 0 00.994 0 .703.703 0 000-.995z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.f8915dd1.svg";
export { ForwardRef as ReactComponent };